import { TextField } from "@mui/material";
import { Ref } from "react";
interface props {
	name: string;
	value?: string;
	label?: string;
	width?: number;
	inputRef?: Ref<HTMLInputElement>;
	handleChange: (event: any) => void;
	handleClear?: (filterId: string) => void;
}

export const InputText = ({
	name,
	value,
	label,
	width,
	handleChange,
	handleClear,
	inputRef
}: props) => {
	return (
		<div className="flex w-100">
			<TextField
				inputRef={inputRef}
				type="text"
				value={value}
				name={name}
				label={label}
				variant="standard"
				onChange={handleChange}
				size="small"
				style={width ? { width } : undefined}
			/>
			{handleClear && (
				<img
					src="images/svg/close-black.svg"
					alt="clear"
					onClick={() => handleClear(name)}
					width="12"
					height="12"
					className="mt-4 ml-4"
				/>
			)}
		</div>
	);
};
